import React from 'react';
import './styles.css';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useRouteMatch, useHistory } from 'react-router-dom';
import TestImage from '@BUP/assets/Images/Resources/ClassRoomActivities/1_3basic.jpeg';
import { useTranslation } from 'react-i18next';

const ClassRoomElement = ({ level }) => {
  const history = useHistory();
  const match = useRouteMatch();
  const [t] = useTranslation();
  return (
    <div className="classroom-element-container">
      <div className="image-wrapper">
        <img src={level?.imgUrl || TestImage} alt={level?.name} />
      </div>
      <div className="classroom-wrapper">
        <h2 className="h2-tag">
          {level?.name || t('pages.resources.textNoLevels')}
        </h2>
        <Button
          type="primary"
          shape="round"
          onClick={() => history.push(`${match.url}/level/${level.id}`)}
        >
          VER <ArrowRightOutlined />
        </Button>
      </div>
    </div>
  );
};

export default ClassRoomElement;
